import type { WidgetInstance } from "@/lib/dashboard/types";
import { getWidget } from "@/lib/dashboard/WidgetRegistry";
import { viewerControlCoverage } from "@/lib/dashboard/viewerControls";

function widgetName(widget: WidgetInstance) {
  const title = widget.config.title;
  return typeof title === "string" && title.trim()
    ? title.trim()
    : (getWidget(widget.widgetId)?.manifest.name ?? widget.widgetId);
}

/** Keep partial filter coverage available on its control without adding a page row. */
export function getFilterImpactHint(
  widgets: readonly WidgetInstance[],
  controls: readonly ("tenants" | "time-range" | "collapse-all" | "events")[],
  control: "tenants" | "time-range",
): string | undefined {
  const coverage = viewerControlCoverage(widgets, controls).find(
    (item) => item.control === control,
  );
  if (!coverage) return undefined;
  const label = control === "tenants" ? "Tenant scope" : "Time range";
  return `${label} applies to ${coverage.affected.length} of ${widgets.length} widgets. Not affected: ${coverage.unaffected.map(widgetName).join(", ")}`;
}
